import React, { createContext, useState, useContext } from "react";

const EnergiaEletricaGeradaContext = createContext();

export default function AmbienteProvider({ children }) {
  const [energiaEletricaGerada_id, setEnergiaEletricaGerada_id] = useState();

  return (
    <EnergiaEletricaGeradaContext.Provider value={{ energiaEletricaGerada_id, setEnergiaEletricaGerada_id }} >
      {children}
    </EnergiaEletricaGeradaContext.Provider>
  );
}

export function useEnergiaEletricaGeradaContext() {
  const context = useContext(EnergiaEletricaGeradaContext);
  //if (!context) throw new Error("useCount must be used within a CountProvider");
  const { energiaEletricaGerada_id, setEnergiaEletricaGerada_id } = context;
  return { energiaEletricaGerada_id, setEnergiaEletricaGerada_id };
}

